export default {
  path: 'news',
  name: 'news',
  redirect: { name: 'news.index' },
  children: [
    {
      path: '',
      name: 'news.index',
      component: () => import('pages/news/IndexPage.vue'),
    },
    {
      path: 'create',
      name: 'news.create',
      component: () => import('pages/news/CreatePage.vue'),
    },
    {
      path: ':id',
      name: 'news.read',
      component: () => import('pages/news/ReadPage.vue'),
    },
    {
      path: 'update/:id',
      name: 'news.update',
      component: () => import('pages/news/CreatePage.vue'),
    },
  ],
}
